module.exports = __webpack_public_path__ + "img/image_19.d437cb5e.png";